import React from 'react';
import {
    Box,          
    Pagination,   
    Select,       
    MenuItem,     
    Typography,   
} from '@mui/material';

// Propos del componente
interface PaginationControlsProps {
    totalCount: number;                     // Número de elementos a paginar
    pagination: {                           
        page: number;                       // Página actual (1-based)
        perPage: number;                    // Elementos por página
    };
    onPageChange: (event: React.ChangeEvent<unknown>, page: number) => void;  
    onPerPageChange: (perPage: number) => void;                              
    pageSizeOptions?: number[];             // Opciones para el selector 
    showItemsPerPage?: boolean;             // Se muestra el selector de elementos por pagina
}

// Componente funcional para los controles de paginación
export const PaginationControls: React.FC<PaginationControlsProps> = ({
    totalCount,                             
    pagination,                             
    onPageChange,                           
    onPerPageChange,                        
    pageSizeOptions = [5, 10, 20, 50],      
    showItemsPerPage = true,                
}) => {

    // Elementos <= minimo elementos por página, no muestra controles de paginación
    if (totalCount <= pageSizeOptions[0]) {
        return null;
    }

    // Total de páginas
    const totalPages = Math.ceil(totalCount / pagination.perPage);

    return (
        // Contenedor principal con estilo flex para alinear los controles
        <Box sx={{
            display: 'flex',
            justifyContent: 'space-between', 
            alignItems: 'center',           
            mt: 2                           
        }}>
            {/* showItemsPerPage == true, selector de elementos por página */}
            {showItemsPerPage && (
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',   
                    gap: 1                  
                }}>
                    
                    <Typography variant="body2">Items por página:</Typography>
                    {/* Selector  */}
                    <Select
                        size="small"        
                        value={pagination.perPage}  
                        // Al cambiar, llamamos a onPerPageChange con el nuevo valor (convertido a número)
                        onChange={(e) => onPerPageChange(Number(e.target.value))}
                        sx={{ minWidth: 80 }} 
                    >
                        
                        {pageSizeOptions.map(size => (
                            <MenuItem key={size} value={size}>{size}</MenuItem>
                        ))}
                    </Select>
                </Box>
            )}
            <Box sx={{flex: 1}}/>
            {/* Paginación numérica */}
            <Pagination
                count={totalPages}          
                page={pagination.page}      
                onChange={onPageChange}     
                color="primary"             
                showFirstButton             
                showLastButton              
            />
        </Box>
    );
};

export default PaginationControls;
